"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var deko_utilities_1 = require("deko-utilities");
var lodash_1 = require("lodash");
var ValidationProvider = function (_a) {
    var linkedFields = _a.linkedFields, validation = _a.validation;
    var ValidationProviderHOC = /** @class */ (function (_super) {
        __extends(ValidationProviderHOC, _super);
        function ValidationProviderHOC(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.runRulesForField = function (value, rulesToCheck, state) {
                for (var ruleName in rulesToCheck) {
                    if (!rulesToCheck.hasOwnProperty(ruleName)) {
                        continue;
                    }
                    if (!deko_utilities_1.rules.hasOwnProperty(ruleName)) {
                        throw Error("Unrecognised ruleName: " + ruleName);
                    }
                    var rule = deko_utilities_1.rules[ruleName];
                    var ruleConfig = rulesToCheck[ruleName];
                    var isValid = rule(value, ruleConfig.constraint, state);
                    if (!isValid) {
                        return ruleConfig.message;
                    }
                }
                return true;
            };
            _this.validateField = function (e, updateErrors) {
                if (updateErrors === void 0) { updateErrors = true; }
                var field = e.target.name;
                var value = e.target.value;
                if (value === undefined) {
                    value = lodash_1.get(_this.props.entity, field);
                }
                var errors = lodash_1.cloneDeep(_this.state.errors);
                var validity = _this.runRulesForField(value, validation[field], _this.props.entity);
                if (validity === true) {
                    deko_utilities_1.objectAccess.deleteKey(field, errors);
                }
                else {
                    deko_utilities_1.objectAccess.setKey(field, errors, validity);
                }
                if (updateErrors) {
                    // run linked fields
                    if (linkedFields[field]) {
                        var updatedEntity_1 = deko_utilities_1.objectAccess.setKey(field, lodash_1.cloneDeep(_this.props.entity), value);
                        linkedFields[field].forEach(function (linked) {
                            var linkedValidity = _this.runRulesForField(lodash_1.get(_this.props.entity, linked), validation[linked], updatedEntity_1);
                            if (linkedValidity === true) {
                                deko_utilities_1.objectAccess.deleteKey(linked, errors);
                            }
                            else {
                                deko_utilities_1.objectAccess.setKey(linked, errors, linkedValidity);
                            }
                        });
                    }
                    _this.setState({ errors: errors });
                }
                return validity;
            };
            _this.validateList = function (whitelist, updateErrors) {
                if (whitelist === void 0) { whitelist = []; }
                if (updateErrors === void 0) { updateErrors = true; }
                var errors = lodash_1.cloneDeep(_this.state.errors);
                var isValid = true;
                Object.keys(validation).forEach(function (field) {
                    if (whitelist.length > 0 && whitelist.indexOf(field) === -1) {
                        return;
                    }
                    var value = lodash_1.get(_this.props.entity, field);
                    var validity = _this.runRulesForField(value, validation[field], _this.props.entity);
                    isValid = isValid && (validity === true);
                    if (validity === true) {
                        deko_utilities_1.objectAccess.deleteKey(field, errors);
                    }
                    else {
                        deko_utilities_1.objectAccess.setKey(field, errors, validity);
                    }
                });
                if (updateErrors) {
                    _this.setState({ errors: errors });
                }
                return isValid;
            };
            _this.removeErrors = function (list) {
                var errors = lodash_1.cloneDeep(_this.state.errors);
                list.forEach(function (field) {
                    deko_utilities_1.objectAccess.deleteKey(field, errors);
                });
                _this.setState({ errors: errors });
            };
            _this.state = {
                errors: {}
            };
            return _this;
        }
        ValidationProviderHOC.prototype.render = function () {
            return (this.props.render({
                errors: this.state.errors,
                validateField: this.validateField,
                validateList: this.validateList,
                removeErrors: this.removeErrors,
            }));
        };
        return ValidationProviderHOC;
    }(React.Component));
    return ValidationProviderHOC;
};
exports.default = ValidationProvider;
